import FootballStatsCategory from "../../../stats/football-stats-category";
import StatsRule from "../../../../common/stats-rule";
import FootballState from "../../../state/football-state";
import { getSafetyTacklingPlayer } from "../../../utils/context-utils";

export default class SafetyRecordStats extends StatsRule {
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Safety &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const teamId = gameContext.getPossessionTeamId();
        const opponentTeamId = gameContext.getOpponent(teamId);
        const tacklingPlayer = getSafetyTacklingPlayer(play, fragment);

        gameContext.increaseTeamScore(opponentTeamId, 2);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: opponentTeamId,
            playerId: tacklingPlayer?.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.SAFETY,
            values: {
                completed: 1
            }
        });
    }
}
